"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function () {
    var Source = function () {
        function Source($t) {
            _classCallCheck(this, Source);

            this.element = $t;
            this.section = $t.closest(".productlistsection");
            this.paramName = $t.attr("data-product-datatable-param-name");
            this.dataTableSelector = $t.attr("data-product-datatable-selector");
            $t.on($t.is(":input") ? "change" : "click", { that: this }, this._handle);
        }

        _createClass(Source, [{
            key: "highlight",
            value: function highlight(enable) {
                var val = this.element.val();
                var emptyVal = val == null || val.length === 0;
                if (enable) {
                    this.section.addClass("highlighted");
                    if (this.isEanSource && !emptyVal) this.element.val("").trigger('change.select2');
                } else {
                    this.section.removeClass("highlighted");
                    if (!emptyVal) this.element.val("").trigger('change');
                }
            }
        }, {
            key: "_handle",
            value: function _handle(e) {
                e.preventDefault();
                var that = e.data.that;
                var productListId = getProductListId();
                var id = that.element.val();

                if (that.isEanSource) {
                    highlightDropdown(that);
                    if (id > 0) {
                        productListService.insertProduct({ ProductId: id, ProductListId: productListId }).done(function () {
                            _notify2.default.success(resx.App.SuccessfullySaved);
                            that._reloadTable();
                        }).fail(function () {
                            return _message2.default.error(resx.Common.AjaxError);
                        });
                        return;
                    }
                }

                if (that.highlatable) {
                    var val = that.element.val();
                    highlightDropdown(val == null || val === "" ? null : that);
                }

                productListService.insertProductListEntry({
                    EntryId: id,
                    ProductListId: productListId,
                    Type: e.target.dataset.productListType
                }).done(function () {
                    _notify2.default.success(resx.App.SuccessfullySaved);
                    window.location.reload();
                }).fail(function () {
                    return _message2.default.error(resx.Common.AjaxError);
                });
            }
        }, {
            key: "_reloadTable",
            value: function _reloadTable() {
                reloadTable();
            }
        }, {
            key: "highlatable",
            get: function get() {
                return !!this.section.length;
            }
        }, {
            key: "isEanSource",
            get: function get() {
                return this.paramName === "productListId";
            }
        }, {
            key: "isHighlighted",
            get: function get() {
                return this.highlatable && this.section.hasClass("highlighted");
            }
        }]);

        return Source;
    }();

    var sources = [];
    var highlightableSources = [];
    var dataArray = {};
    var dataElement = document.getElementById('productListDataSource');
    var queryObject = {
        productListId: getProductListId(),
        seriesId: null,
        editionId: null,
        query: null,
        authorId: null,
        brandId: null
    };

    init();

    function init() {
        if (!dataElement || dataElement.initialized) return;

        fillHolder('series');
        fillHolder('editions');
        fillHolder('authors');
        fillHolder('brands');
        fillHolder('genres');

        (0, _jquery2.default)("[data-product-lists-apply]", this).each(function () {
            var source = new Source((0, _jquery2.default)(this));
            sources.push(source);
            if (source.highlatable) {
                highlightableSources.push(source);
            }
        });

        highlightDropdown();
        (0, _jquery2.default)('#authorFilterDropdown').on('change', filterByAuthorChange);

        dataElement.initialized = true;
    }

    function filterByAuthorChange(event) {
        queryObject.authorId = event.target.value;
        reloadTable();
    }

    function getProductListId() {
        return (document.querySelector('div#products input#Id') || {}).value;
    }

    function fillHolder(dataParamName) {
        try {
            var holderElement = document.getElementById(dataParamName + "Holder");

            var entryArray = dataArray[dataParamName] = JSON.parse(dataElement.dataset[dataParamName]);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = entryArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var entry = _step.value;

                    var entryElement = _common2.default.createElement('div', holderElement, { textContent: entry.Name });
                    var deleteButton = _common2.default.createElement('a', entryElement, { href: '#', title: resx.Common.Delete });
                    deleteButton.addEventListener('click', deleteProductListGroup);
                    var deleteIcon = _common2.default.createElement('i', deleteButton, { className: 'fa fa-remove' });
                    deleteIcon.id = deleteButton.id = deleteButton.dataset.id = entryElement.dataset.id = entry.Id;
                    deleteIcon.deleteGroupType = deleteButton.deleteGroupType = deleteButton.dataset.deleteGroupType = dataParamName;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } catch (e) {
            console.error('Error in fillHolder function', e);
        }
    }

    function deleteProductListGroup(event) {
        _message2.default.confirm(Resx.Messages.ConfirmDelete, Resx.Messages.ConfirmTitle).then(function () {
            var id = event.target.id;
            var deleteGroupType = event.target.deleteGroupType;
            var productListId = getProductListId();
            productListService.deleteProductListEntry({
                Type: deleteGroupType,
                ProductListId: productListId,
                EntryId: id
            }).done(function () {
                window.location.reload();
            });
        }).catch(function (err) {
            console.error(err);
        });
    }

    function highlightDropdown(toHighlight) {
        if (!toHighlight) {
            toHighlight = highlightableSources.find(function (src) {
                var val = src.element.val();
                return val != null && val !== "";
            });
            if (!toHighlight) {
                toHighlight = highlightableSources.find(function (src) {
                    return src.isEanSource;
                });
            }
        }
        highlightableSources.forEach(function (src) {
            src.highlight(src === toHighlight);
        });
    }

    function reloadTable() {
        var datatable = (0, _jquery2.default)('#productsTable').DataTable();
        datatable.query(queryObject).ajax.reload(null, false);
    }

    (0, _jquery2.default)(".switch-toggle input[type=checkbox]", this).on("change", function () {
        var source = null;
        if ((0, _jquery2.default)(this).is(":checked")) {
            source = sources.find(function (src) {
                return !src.highlatable;
            });
        } else {
            source = sources.find(function (src) {
                return src.isHighlighted;
            });
        }
        if (source) source._reloadTable();
    });

    (0, _jquery2.default)("[data-modal-ok]", this).click(function (e) {
        e.preventDefault();
        var $modal = (0, _jquery2.default)(this).closest(".modal");
        var data = (0, _jquery2.default)(".modal").find(":input").serializeArray();
        var returnArray = { 'name': 'N/A' };
        for (var i = 0; i < data.length; i++) {
            returnArray[data[i]['name'].replace("productListModalForm.", "")] = data[i]['value'];
        }
        productListService.save(returnArray).done(function (result) {
            var select2 = (0, _jquery2.default)($modal.children("div").attr("data-dropdown-target"));
            var option = new Option(result.name, result.id);
            option.selected = true;

            for (var _i = 0; _i < sources.length; _i++) {
                if (sources[_i].isEanSource) {
                    sources[_i].element.val("").trigger('change');
                    sources[_i]._reloadTable();
                }
            }

            select2.append(option);
            select2.trigger("change");
            $modal.modal('toggle');
        }).fail(function () {
            _message2.default.error(resx.Common.AjaxError);
        });
    });

    (0, _jquery2.default)('a[data-product-lists-action-delete]', this).on('click', function () {
        var $t = (0, _jquery2.default)(this).closest(".dataTable");
        var $table = $t.DataTable();
        var data = $table.row((0, _jquery2.default)(this).parents('tr')).data();
        var productId = data.id;
        var productListId = getProductListId();

        _message2.default.confirm(Resx.Messages.ConfirmDelete, Resx.Messages.ConfirmTitle).then(function () {
            productListService.deleteProduct({ ProductId: productId, ProductListId: productListId }).done(function () {
                $table.ajax.reload(null, false);
            });
        }).catch(function () {});
    });
};

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

var _notify = require("linksoft/notify");

var _notify2 = _interopRequireDefault(_notify);

var _message = require("linksoft/message");

var _message2 = _interopRequireDefault(_message);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _common = require("./common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var productListService = abp.services.api.productList;

var resx = (0, _localize2.default)("Common", "App", "Message");

;

(0, _jquery2.default)(document).on('click', '#closeModalCross', function () {
    (0, _jquery2.default)("#productsTable").DataTable().ajax.reload(null, false);
});

(0, _jquery2.default)(document).on('click', '#closeModal', function () {
    (0, _jquery2.default)("#productsTable").DataTable().ajax.reload(null, false);
});

(0, _jquery2.default)(document).on('click', '#form0', function (e) {
    e.stopPropagation();
    return true; // This should not be used unless you do not want
    // any click events registering inside the div
});

(0, _jquery2.default)(document).on('click', "#import-new-list", function () {
    (0, _jquery2.default)("#productsTable").DataTable().ajax.reload(null, false);
});

// problem with select2 and bootstrap modal
// solution: https://stackoverflow.com/questions/18487056/select2-doesnt-work-when-embedded-in-a-bootstrap-modal
_jquery2.default.fn.modal.Constructor.prototype.enforceFocus = function () {};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/productLists.js
// module id = 446
// module chunks = 0